<template>
  <div class="course-menu gh-credential-quick-links">
    <el-menu
      defaultActive="actions"
      :defaultOpeneds="['actions']"
      class="gh-sidebar__menu"
      ref="menu">
      <el-menu-item v-if="isUnit" index="complete" class="is-cyan">
        <a class="gh-menu__item" @click="dialogVisible = true">
          <span class="gh-menu__label">How to complete this section</span>
          <span class="gh-menu__icon"><i class="el-icon-warning-outline"></i></span>
        </a>
      </el-menu-item>

      <el-menu-item index="course-guide" class="is-cyan">
        <a class="gh-menu__item" :href="course.courseGuide" target="_blank">
          <span class="gh-menu__label">Download your Course Guide</span>
          <span class="gh-menu__icon"><i class="el-icon-download"></i></span>
        </a>
      </el-menu-item>

      <el-submenu index="actions" class="gh-submenu">
        <el-menu-item index="title">
          <a class="gh-menu__item">
            <span class="gh-menu__label is-heading">Actions</span>
          </a>
        </el-menu-item>
        <el-menu-item v-if="isUnit" index="actions-assessment">
          <router-link class="gh-menu__item" :to="assessmentPath">
            <span class="gh-menu__label">Go to Assessment</span>
            <div class="gh-menu__icon">
              <img src="/images/app/arrow-circle-right.svg" alt="arrow-right">
            </div>
          </router-link>
        </el-menu-item>

        <el-menu-item index="actions-assessment">
          <a class="gh-menu__item" :href="course.facebookGroup" target="_blank">
            <span class="gh-menu__label">Go to Facebook Group</span>
            <div class="gh-menu__icon">
              <img src="/images/app/arrow-circle-right.svg" alt="arrow-right">
            </div>
          </a>
        </el-menu-item>

        <el-menu-item index="actions-assessment">
          <a class="gh-menu__item" href="mailto:help@mentalhealthacademy.com.au">
            <span class="gh-menu__label">Email Support Team</span>
            <div class="gh-menu__icon">
              <img src="/images/app/arrow-circle-right.svg" alt="arrow-right">
            </div>
          </a>
        </el-menu-item>
      </el-submenu>
    </el-menu>
    <el-dialog
      title="How to complete this section"
      :visible.sync="dialogVisible"
      :width="dialogWidth"
      custom-class="gh-credential__dialog">
      <div class="">
        <p>To complete this unit, you should:</p>
        <ol>
          <li>Download and read the requisite reading</li>
          <li>Watch the unit’s video lecture</li>
          <li>Complete the multiple-choice assessment</li>
        </ol>

        <p>We also recommend taking on the tasks suggested in the "Activities and Tools" section of each Unit, and exploring the supplemental learning resources provided. And above all, enjoy your learning!</p>
      </div>
      <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false" class="gh-button gh-button--primary">Close</el-button>
      </span>
  </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      course: {
        type: Object,
        required: true
      }
    },

    data () {
      return {
        dialogVisible: false
      }
    },

    computed: {
      isUnit () {
        return this.assessmentPath.indexOf('unit') > 0
      },
      assessmentPath () {
        let path = this.$route.path
        if (path.indexOf('result') > 0) {
          path = path.replace('/result', '')
        }
        return `${path}/assessment`
      },

      dialogWidth() {
        return this.device !=='widescreen' ? '85%' : '30%'
      },

      device() {
        return this.$store.getters['ui/getDevice'];
      }
    }
  }
</script>

<style lang="scss">
  .gh-credential__dialog {
    .el-dialog__body {
      padding-top: .5rem;
      padding-bottom: 0;
    }
    .dialog-footer {
      width: 100px;
      display: inline-block;
    }
    p {
      word-break: keep-all;
      font-size: 1rem;
      margin-bottom: 1rem;
    }

    ol {
      margin-bottom: 1rem;
      li {
        font-size: 1rem;
        + li {
          margin-top: .5rem;
        }
      }
    }

    .gh-button {
      margin-top: 0 !important;
    }
  }
  .gh-credential-quick-links {
    .el-submenu__title {
      display: none;
    }

    .el-menu-item {
      border: 0 !important;
    }

    .gh-menu__item {
      justify-content: space-between;
    }

    .gh-menu__label {
      font-size: 1.1rem;
      font-weight: 600;
      max-width: 70%;
      white-space: normal;
    }

    .gh-menu__icon {
      display: flex;
      justify-content: center;
      margin-right: 0;

      i {
        margin-right: 0;
        font-size: 28px;
        color: #C3C8D2;
      }
    }

    .gh-submenu {
      .gh-menu__label {
        color: #514A9D !important;

        &.is-heading {
          font-size: 1.5rem;
          color: #085078 !important;
        }
      }
    }

    .gh-submenu .el-menu-item:hover {
      background: #ecf5ff;
    }
    .gh-submenu .el-menu-item.is-active {
      background: white !important;
      &:hover {
        background: #ecf5ff !important;
      }
    }
  }
  @media (max-width: 1023px){
    .gh-credential-quick-links {
      margin-top: 2rem;
    }
  }

  @media (max-width: 834px) {
    .gh-credential-quick-links .gh-sidebar__menu {
      margin-left: 1rem;
      padding: .5rem 0;
    }

    .gh-credential-quick-links .gh-sidebar__menu .gh-submenu .el-menu-item a,
    .gh-credential-quick-links .gh-sidebar__menu > .el-menu-item a {
      padding: .5rem 10px
    }
  }
</style>
